import React from "react";
import leftPng from "../../../../content/images/left.png";

const Detail = () => {
  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Maatregelen in detail</div>
      <div className="mt5">
        <a className="back-page-link" role="button">
          <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
          maatregelen
        </a>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Gisratio ID</div>
            <div className="box-title-2-active" id="algemeenGisratioid" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Maatregel</div>
            <div className="box-title-2" id="maatregelNaam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Planningspatroon</div>
            <div className="box-title-2" id="planningspatroon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
